module.exports = __webpack_public_path__ + "static/media/bleeding-wound.8d92779f.svg";